import React from "react";
import { Col, Row } from "react-bootstrap";
import { Schedule, Description, Chat, Publish } from "@material-ui/icons";
import moment from "moment";
import TimeAgo from "react-timeago";
import PhoneNumber from "../Common/phoneNumber";
import InfiniteScroll from "react-infinite-scroller";

class NotificationList extends React.Component {
  /**
   * @desc show over due  & due todays notification list
   */
  getOverDueAndDueTodayNotifications(noti) {
    let tasks = noti.task;
    let totalCnt = !!tasks ? tasks.length : 0;
    let unreadClass = noti.read ? "" : "unread";
    let date = moment(noti.createdDate).format("YYYY-MM-DD hh:mm a");

    let notificationDisplay = [];

    if (noti.notificationType === 1) {
      notificationDisplay.push(
        <p key={noti._id}>There are total {totalCnt} tasks overdue:</p>
      );
    } else {
      notificationDisplay.push(
        <p key={noti._id}>There are total {totalCnt} task due today:</p>
      );
    }
    let singleNoti = [];
    tasks.map((details) => {
      singleNoti.push(
        <li key={noti._id + details._id}>
          <a
            onClick={() => {
              if (this.props.fromHeader) {
                this.props.readNotification(noti._id);
                localStorage.setItem("taskId", details.taskId);
              }

              this.props.history.push({
                pathname: "/artwork/detail/" + details.transactionId,
                taskId: details.taskId,
              });
            }}
          >
            {details.transactionShortName} - {details.taskTitle}
          </a>
        </li>
      );
    });
    notificationDisplay.push(
      <>
        <ul>{singleNoti}</ul>
        <h6 className="font-14 font-400 font-italic color-grey-1 mb-0">
          <Schedule />
          <TimeAgo date={date} />
        </h6>
      </>
    );

    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-orange">
              <Description />
            </div>
          </Col>
          <Col className="pl-0">
            <h4>
              {noti.notificationType === 1 ? "Tasks OverDue" : "Task Due Today"}
            </h4>
            {notificationDisplay}
          </Col>
        </Row>
      </div>
    );
  }

  /**
   * @desc display of list of notifications of upload documents
   */
  getUploadDocNotificaions(notifications) {
    let tasks = notifications.task;
    let unreadClass = notifications.read ? "" : "unread";
    let date = moment(notifications.createdDate).format("YYYY/MM/DD hh:mm a");

    let notificationDisplay = [];
    tasks.map((n) => {
      notificationDisplay.push(
        <>
          <a
            onClick={() => {
              if (this.props.fromHeader) {
                this.props.readNotification(notifications._id);
                localStorage.setItem("doc", true);
              }

              this.props.history.push({
                pathname: "/artwork/detail/" + n.transactionId,
                document: true,
                notification: true,
              });
            }}
          >
            <p>
              Document has been uploaded by{" "}
              <span className="color-light-blue-1 font-500">
                {this.getDisplayName(n)}
              </span>{" "}
              for transaction{" "}
              <span className="color-light-blue-1 font-500">
                {n.transactionShortName}
              </span>
            </p>
          </a>
          <h6 className="font-14 font-400 font-italic color-grey-1 mb-0">
            <Schedule /> <TimeAgo date={date} />{" "}
          </h6>
        </>
      );
    });
    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-blue">
              <Publish />
            </div>
          </Col>
          <Col className="pl-0">
            <h4>Document Uploaded</h4>
            {notificationDisplay}
          </Col>
        </Row>
      </div>
    );
  }

  /**
   * @desc get name of user for display within notification
   * @param {*} n
   */
  getDisplayName(n) {
    let displayName = "unknown";
    if (n.from._id !== undefined) {
      displayName = n.from.firstname + " " + n.from.lastname;
    } else {
      if (n.from.email !== undefined && n.from.email.address !== undefined) {
        displayName = n.from.email.address;
      }
      if (n.from.mobileNumber !== undefined) {
        displayName = <PhoneNumber phoneNumber={n.from.mobileNumber} />;
      }
    }
    return displayName;
  }

  /**
   * @desc display of list of notifications of new message
   */
  getNewMsgNotifications(notifications) {
    let tasks = notifications.task;
    let unreadClass = notifications.read ? "" : "unread";
    let date = moment(notifications.createdDate).format("YYYY-MM-DD hh:mm a");

    let notificationDisplay = [];
    tasks.map((n) => {
      notificationDisplay.push(
        <>
          <a
            onClick={() => {
              if (this.props.fromHeader) {
                this.props.readNotification(notifications._id);
                localStorage.setItem("discussion", true);
                localStorage.setItem("from", n.from);
              }
              this.props.history.push({
                pathname: "/artwork/detail/" + n.transactionId,
                discussion: true,
                from: n.from,
              });
            }}
          >
            <p>
              New message received from{" "}
              <span className="color-light-blue-1 font-500">
                {this.getDisplayName(n)}
              </span>{" "}
              for transaction{" "}
              <span className="color-light-blue-1 font-500">
                {n.transactionShortName}
              </span>
            </p>
          </a>

          <h6 className="font-14 font-400 font-italic color-grey-1 mb-0">
            <Schedule /> <TimeAgo date={date} />{" "}
          </h6>
        </>
      );
    });
    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-yellow">
              <Chat />
            </div>
          </Col>
          <Col className="pl-0">
            <h4>New Message</h4>
            {notificationDisplay}
          </Col>
        </Row>
      </div>
    );
  }

  /**
   * @desc display of list of notifications of payment methods
   */
  getPaymentMethodNotificaions(notifications) {
    let message = notifications.message;
    let unreadClass = notifications.read ? "" : "unread";
    let date = moment(notifications.createdDate).format("YYYY/MM/DD hh:mm a");

    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-blue">
              <Publish />
            </div>
          </Col>
          {/* <Col className="pl-0" onClick={() => {
            if (this.props.fromHeader) {
              this.props.readNotification(notifications._id);
            }
            this.props.history.push("/Subscription/SubscriptionDetail");
          }}>
            <h4>Update payment method</h4>
            <p>{message}</p>

            <h6 className="font-14 font-400 font-italic color-grey-1 mb-0"><Schedule /> <TimeAgo date={date} /> </h6>
          </Col> */}
        </Row>
      </div>
    );
  }
  /**
   * @desc display of list of notifications of require actions
   */
  getRequireActionNotificaions(notifications) {
    let message = notifications.message;
    let unreadClass = notifications.read ? "" : "unread";
    let date = moment(notifications.createdDate).format("YYYY/MM/DD hh:mm a");

    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-blue">
              <Publish />
            </div>
          </Col>
          <Col className="pl-0">
            <h4>Require Action (authentication)</h4>
            <p>
              {message}
              <a
                href={notifications.redirectionURL}
                target="_blank"
                onClick={() => {
                  if (this.props.fromHeader) {
                    this.props.readNotification(notifications._id);
                  }
                }}
              >
                Click here
              </a>
              &nbsp;for authentication.
            </p>

            <h6 className="font-14 font-400 font-italic color-grey-1 mb-0">
              <Schedule /> <TimeAgo date={date} />{" "}
            </h6>
          </Col>
        </Row>
      </div>
    );
  }
  /**
   * @desc display of list of notifications of require actions
   */
  getInvoiceActionNotificaions(notifications) {
    let message = notifications.message;
    let unreadClass = notifications.read ? "" : "unread";
    let date = moment(notifications.createdDate).format("YYYY/MM/DD hh:mm a");

    return (
      <div className={"notification-single " + unreadClass}>
        <Row>
          <Col className="col-auto">
            <div className="nf-icn nf-blue">
              <Publish />
            </div>
          </Col>
          <Col className="pl-0">
            <h4>Upcoming invoice</h4>
            <p>{message}</p>

            <h6 className="font-14 font-400 font-italic color-grey-1 mb-0">
              <Schedule /> <TimeAgo date={date} />{" "}
            </h6>
          </Col>
        </Row>
      </div>
    );
  }
  /**
   * Render notifications data based on type
   */
  renderNotifications() {
    let notifications = this.props.notificationlist;
    let data = [];
    notifications.map((noti) => {
      //tyep 1 = over due
      if (noti.notificationType === 1) {
        data.push(this.getOverDueAndDueTodayNotifications(noti));
      }
      //type 2 = due today
      if (noti.notificationType === 2) {
        data.push(this.getOverDueAndDueTodayNotifications(noti));
      }
      if (noti.notificationType === 3) {
        data.push(this.getUploadDocNotificaions(noti));
      }
      if (noti.notificationType === 4) {
        data.push(this.getNewMsgNotifications(noti));
      }
      if (noti.notificationType === 5) {
        data.push(this.getPaymentMethodNotificaions(noti));
      }
      if (noti.notificationType === 6) {
        data.push(this.getRequireActionNotificaions(noti));
      }
      if (noti.notificationType === 7) {
        data.push(this.getInvoiceActionNotificaions(noti));
      }
    });
    return data;
  }

  /**
   * @desc load more notification on scroll
   */
  loadMoreNotifications() {
    this.props.getNotifications();
  }

  render() {
    if (this.props.fromHeader) {
      return this.renderNotifications();
    } else {
      return (
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreNotifications.bind(this)}
          hasMore={this.props.hasMoreItems}
          loader={
            <div className="loader" key={0}>
              <div style={{ position: "absolute", left: "50%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          }
        >
          {this.renderNotifications()}
        </InfiniteScroll>
      );
    }
  }
}

export default NotificationList;
